import Logo from "./logo.svg";
import Settings from "./settings.svg";
import Search from "./search.svg";
import Close from "./close.svg";
import Arrow from "./arrow.svg";
import ArrowRaster from "./arrow-png.png"
import Play from "./play.svg";
import Warning from "./warning.svg";
import ToggleOff from "./toggle-off.svg";
import ToggleOn from "./toggle-on.svg";
import Check from "./tick.svg";
import Loading from "./loading.svg";
import StarhubLogo from "./starhub.svg";
import AffiliateStarhubLogo from "./starhublogo.svg";
import AffiliateSingtelLogo from "./singtellogo.svg";
import UnifiLogo from "./unifi-logo.png";
import AboutImage from "./about-image.png";
import SmallFallback from "./fallback-small.png";
import LargeFallback from "./fallback-large.png";

import BBCBrit from "./channels/brit.svg";
import CBeebies from "./channels/cbeebies.svg";
import BBCEarth from "./channels/earth.svg";
import BBCFirst from "./channels/first.svg";
import BBCLifestyle from "./channels/lifestyle.svg";
import BBCWorldNews from "./channels/worldnews.svg";
import BBCBrit_DEF from "./channels/default/BBC-Brit.svg";
import CBeebies_DEF from "./channels/default/CBeebies.svg";
import BBCEarth_DEF from "./channels/default/BBC-Earth.svg";
import BBCFirst_DEF from "./channels/default/BBC-First.svg";
import BBCLifestyle_DEF from "./channels/default/BBC-Lifestyle.svg";
import Download from "./download.svg";
import TvGuide from "./tv-guide.svg";
import SignIn from "./sign-in.svg";
import PinkDownload from "./more/More-Downloads-Selected.svg";
import PinkTvGuide from "./more/More-TV-Schedule-Selected.svg";
import PinkSignIn from "./more/More-Sign-In-Selected.svg";
import PinkDivider from "./pink-stoke.svg";
import ChevronLeft from "./chevron-left.svg";
import ChevronRight from "./chevron-right.svg";
import DisChevronLeft from "./chevron-left-disabled.svg";
import DisChevronRight from "./chevron-right-disabled.svg";
import Live from "./live.svg";
import PlayButton from "./play-button.svg";
import PinkPlayButton from "./pink-playbutton.svg";
import LiveCbeebies from "./channels/elongated/Live-CBeebies.svg";
import LiveEarth from "./channels/elongated/Live-Earth.svg";
import LiveLifestyle from "./channels/elongated/Live-Lifestyle.svg";
import Calender from "./calender.svg";

import AudioSVG from "./audio.svg";

const Image = {
    Logo,
    Settings,
    Search,
    Close,
    Arrow,
    ArrowRaster,
    Play,
    Warning,
    ToggleOff,
    ToggleOn,
    Check,
    Loading,
    StarhubLogo,
    AffiliateStarhubLogo,
    AffiliateSingtelLogo,
    UnifiLogo,
    BBCBrit,
    BBCEarth,
    BBCFirst,
    BBCLifestyle,
    BBCWorldNews,
    CBeebies,
    AboutImage,
    SmallFallback,
    LargeFallback,
    BBCBrit_DEF,
    CBeebies_DEF,
    BBCEarth_DEF,
    BBCFirst_DEF,
    BBCLifestyle_DEF,
    Download,
    TvGuide,
    SignIn,
    PinkTvGuide,
    PinkDownload,
    PinkSignIn,
    PinkDivider,
    ChevronLeft,
    ChevronRight,
    Live,
    PlayButton,
    PinkPlayButton,
    LiveCbeebies,
    LiveEarth,
    LiveLifestyle,
    DisChevronLeft,
    DisChevronRight,
    Calender,
    AudioSVG
};

export { Image };
